<template>
    <div class="detail-container">
        <div class="detail-left-side">
            <el-skeleton :rows="1" animated v-if="detailLoading">
                <template slot="template">
                    <div class="user-action-skeleton">
                        <el-skeleton-item variant="p" style="width: 100%; height: 100%;"/>
                    </div>
                </template>
            </el-skeleton>
            <userAction ref="panel"
                        :likeStatus="articDetail.articleInfo.likeStatus"
                        :likeCount="articDetail.articleInfo.likeCount"
                        :commentCount="articDetail.articleInfo.commentCount"
                        :collectStatus="articDetail.articleInfo.collectStatus"
                        :collectCount="articDetail.articleInfo.collectCount"
                        :reportStatus="articDetail.articleInfo.reportStatus"
                        @handleLike="handleLike"
                        @handleCollect="handleCollect"
                        @handleReport="handleReport"
                        v-else></userAction>
        </div>
        <div class="detail-main">
            <div class="detail-block shadow">
                <div v-if="!detailLoading">
                    <div class="detail">
                        <!-- 不展示封面图片 -->
                        <!-- <div v-if="articDetail.articleInfo.coverImage" class="detail__cover"
                        :style="`background-image: url(${articDetail.articleInfo.coverImage})`"></div> -->
                        <h1 class="detail__title">{{ articDetail.articleInfo.title }}</h1>
                        <div class="detail__userInfo">
                            <router-link :to="'/user/' + articDetail.userInfo.userId" class="detail__user__name"
                                        target="_blank">
                                <span>{{ articDetail.userInfo.nickName }}</span>
                            </router-link>
                            <div class="detail__user__meta">
                                <span class="meta__time">{{ '发布于 ' + articDetail.articleInfo.createTime }}</span>
                            </div>
                        </div>
                        <div class="detail__content" v-html="articDetail.articleInfo.descContent"></div>
                    </div>
                    <div class="tags" v-if="articDetail.tags && articDetail.tags.length > 0">
                        <span class="tags__title">标签：</span>
                        <router-link :to="'/tag?name=' + item.name" v-for="item in articDetail.tags" :key="item.tagId"
                                    class="tag"
                                    target="_blank">
                            <span class="tag__title">{{ item.name }}</span>
                        </router-link>
                    </div>
                </div>
                
                <div class="comment-area shadow" v-if="!commentsLoading">
                    <p class="comment-area__title">评论<span>{{ commentInfo.total }}</span></p>
                    <publish-comment @publishComment="publishComment" placeholder="发表你的评论吧！"></publish-comment>
                    <div class="comment__sort">
                        <span class="comment__sort-item" :class="{ 'comment__sort-item--active': item.id === navId }" v-for="(item,index) in navs" :key="index" @click="changeNavType(item)"> {{ item.title }}</span>
                    </div>
                    <div>
                        <comment-item v-for="(item, index) in comments" :key="item.id" :index="index"
                                      :author-id="articDetail.userInfo.userId" :data="item"
                                      @reply-more="getMoreReply" @reply="reply"></comment-item>
                        <div v-if="commentInfo.hasMore" class="comment__more-btn" @click="getMoreComment">查看更多</div>
                        <el-empty v-if="!commentsLoading && comments.length === 0" style="height: 590px;"  description="暂无数据" />
                    </div>
                </div>
            </div>
             <!-- 骨架屏 -->
             <el-skeleton :rows="1" animated v-if="detailLoading">
                <template slot="template">
                    <div class="detail-block shadow skeleton-item">
                        <el-skeleton-item variant="p" style="width: 100%; height: 122px;" class="detail"/>
                        <el-skeleton-item variant="p" style="width: 100%; height: 18px;" class="tags"/>
                    </div>
                </template>
            </el-skeleton>
            <el-skeleton :rows="1" animated v-if="commentsLoading">
                <template slot="template">
                    <div class="detail-block shadow skeleton-item">
                        <el-skeleton-item variant="p" style="width: 100%; height: 400px;" class="comment-area shadow"/>
                    </div>
                </template>
            </el-skeleton>
        </div>
        <!-- <div class="detail-right-side">
          <about-author :info="articDetail" :showInfo="true" :showFollowbtn="true"></about-author>
          <catalog></catalog>
        </div> -->
        <!-- 举报弹框 -->
        <ReportComp v-if="isShowReportModel" :targetId="articDetail.articleInfo.articleId" @close="closeReport" @reportSuccess="reportSuccess" />
        <!-- 评论弹窗 -->
        <el-dialog :visible.sync="isShowCommentModel" :title="'回复用户:' + (replyData ? replyData.data.userInfo.nickName : '')" width="700px">
            <publish-comment @publishComment="replyComment" placeholder="发表你的评论吧！"></publish-comment>
        </el-dialog>
    </div>
</template>

<script>
// import markdownit from 'markdown-it'
// import highlight from 'highlight.js'
import ReportComp from '@/components/business/report/index.vue'
import aboutAuthor from '@/components/business/detail/aboutAuthor.vue'
import userAction from '@/components/business/detail/userAction.vue'
// import articleSuspendedPanel from '~/components/business/detail/articleSuspendedPanel'
import catalog from '@/components/business/detail/catalog.vue'
import {getArticleList, insertUserComment, doAction, getUserCommentCommunityList} from '@/api';

export default {
    components: {
        aboutAuthor,
        userAction,
        catalog,
        ReportComp
    },
    data() {
        return {
            isShowReportModel: false,
            isShowCommentModel: false,
            replyData: null,
            articDetail: {},
            navId: 1,
            navs: [
                {
                    id: 1,
                    title: '最新',
                    type: 1
                },
                {
                    id: 2,
                    title: '最热',
                    type: 2
                },
            ],
            comments: [
                
            ],
            pageNum: 1,
            pageSize: 10000,
            // 评论分页信息
            commentInfo: {
                total: 0,
                hasMore: false,
            },
            tagIds: '',
            detailLoading: true,
            commentsLoading: true,
        }
    },

    async created() {
        await this.getArticleDetail()
        this.getCommentList()
        
    },

    mounted() {
        this.setTagIds()
        if (location.hash === '#comment') {
            this.$refs.panel.scrollIntoComment()
        }
    },
    
    updated() {
        // 在DOM更新后处理图片
        this.processArticleImages();
    },
    methods: {
        closeReport() {
            this.isShowReportModel = false;
        },
        reportSuccess() {
            this.isShowReportModel = false;
            this.articDetail.articleInfo.reportStatus = '1';
        },
        getMoreComment() {
            if (this.commentInfo.hasMore) {
                this.getCommentList()
            }
        },
        changeNavType(item) {
            if (this.navId !== item.id) {
                this.navId = item.id
            }
            this.pageNum = 1
            this.comments = []
            this.loading = true;
            this.getCommentList();
        },
        async getArticleDetail() {
            const response = await getArticleList({
                articleId: this.$route.params.id
            });
            if (response && response.rows && response.rows.length > 0) {
                this.articDetail = response.rows[0]
                this.commentInfo.total = this.articDetail.articleInfo.commentCount
            }
            this.detailLoading = false
        },
        setTagIds() {
            if (this.articDetail.tags) {
                this.tagIds = this.articDetail.tags.map(item => item.tagId)
            }
        },
        // 获取评论
        getCommentList() {
            this.commentsLoading = true;
            let params = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                targetType: 6,
                targetId: this.articDetail.articleInfo.articleId,
                params: {}
            }
            params.params.order = 'desc'
            if (this.navId === 1) { 
                params.params.sort = 'create_time'
            } else if(this.navId === 2) {
                params.params.sort = 'like_count'
            }
            getUserCommentCommunityList(params).then(res => {
                this.comments = this.comments.concat(res.rows);
                // 更新评论总数（使用后端返回的总数，而不是当前加载的数量）
                if (res.total !== undefined) {
                    this.commentInfo.total = res.total;
                    this.articDetail.articleInfo.commentCount = res.total;
                }
                // 判断是否还有更多评论
                if(res.rows.length < this.pageSize) {
                    this.commentInfo.hasMore = false;
                } else {
                    this.commentInfo.hasMore = true;
                    this.pageNum++;
                }
                this.commentsLoading = false;
            })
        },
        // 发布评论
        async publishComment(content) {
            if (!this.$store.state.user.token) {
                this.$router.push("/login/account");
                return
            }
            const response = await insertUserComment({
                targetType: 6,  // 6 文章
                targetId: this.articDetail.articleInfo.articleId,
                content: content,
            }).catch(err => {
                this.$message.error(err);
            });
            if (response && response.code === 200) {
                this.$message.success('评论成功');
                this.comments = [];
                this.pageNum = 1;
                this.getCommentList();
            }
        },
        async replyComment(content) {
            if (!this.$store.state.user.token) {
                this.$router.push("/login/account");
                return
            }
            let targetId = '';
            if(this.replyData.type == 'comment') {
                targetId = this.replyData.data.commentInfo.commentId;
            } else {
                targetId = this.replyData.data.replayInfo.commentId;
            }
            const response = await insertUserComment({
                targetType: 5,  // 5 评论
                targetId: targetId,
                content: content,
            }).catch(err => {
                this.$message.error(err);
            });;
            if (response && response.code === 200) {
                this.isShowCommentModel = false;
                this.$message.success('回复成功');
                this.comments = [];
                this.pageNum = 1;
                this.getCommentList();
            }
        },
        reply(replyData) {
            this.isShowCommentModel = true;
            this.replyData = replyData;
        },
        // 点赞行为
        handleLike(status) {
            this.articDetail.articleInfo.likeStatus = status;
            doAction({
                actionType: 1,
                targetId: this.articDetail.articleInfo.articleId,
                targetType: 6,
                status: status
            }).then(res => {
                status === '1' ? this.articDetail.articleInfo.likeCount += 1 : this.articDetail.articleInfo.likeCount -= 1
                if (status === '1') {
                    this.$message.success('点赞成功');
                } else {
                    this.$message.success('取消点赞成功');
                }
            })
        },
        // 收藏行为
        handleCollect(status) {
            this.articDetail.articleInfo.collectStatus = status;
            doAction({
                actionType: 3,
                targetId: this.articDetail.articleInfo.articleId,
                targetType: 6,
                status: status
            }).then(res => {
                status === '1' ? this.articDetail.articleInfo.collectCount += 1 : this.articDetail.articleInfo.collectCount -= 1
                if (status === '1') {
                    this.$message.success('收藏成功');
                } else {
                    this.$message.success('取消收藏成功');
                }
            });
        },
        // 举报行为
        handleReport() {
            this.isShowReportModel = true
        },
        // 更多回复
        getMoreReply({index}) {
            // let comment = this.comments[index]
            // this.$api.getReplyList({
            //     item_type: 2,
            //     item_id: this.$route.params.id,
            //     limit: 5,
            //     cursor: comment.cursor || '',
            //     comment_id: comment.comment_id,
            // }).then(res => {
            //     if (res.err_no === 0) {
            //         comment.replyInfos = comment.cursor ? comment.replyInfos.concat(res.data) : res.data
            //         comment.cursor = res.cursor
            //         comment.has_reply_more = res.has_more
            //     }
            // })
        },
        
        // 处理文章中的图片，确保尺寸合适
        processArticleImages() {
            if (this.detailLoading) return;
            
            this.$nextTick(() => {
                const contentEl = document.querySelector('.detail__content');
                if (!contentEl) return;
                
                const images = contentEl.querySelectorAll('img');
                images.forEach(img => {
                    // 设置最大宽度为70%，与编辑器中上传时一致
                    img.style.maxWidth = '70%';
                    img.style.height = 'auto';
                    img.style.margin = '10px auto';
                    img.style.display = 'block';
                });
            });
        }
    }
}
</script>

<style lang='scss' scoped>
.detail-container {
    display: flex;
    min-width: 620px;

    .detail-left-side {
        .user-action-skeleton {
            padding: 16px;
            width: 60px;
            margin-top: 45px;
            background: #fff;
            border-radius: 10px;
            height: 272px;
        }
    }

    .detail-main {
        width: 800px;
        margin-right: 20px;
        margin-left: 20px;

        .detail-block {
            padding: 16px;
            background: #fff;
            border-radius: 10px;

        }

        .comment-area {
            margin-top: 20px;
            padding: 16px;
            border-radius: 10px;
            background-color: #fff;

            .comment__sort {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin: 20px 0px;

                .comment__sort-item {
                    display: flex;
                    align-items: center;
                    font-size: 16px;
                    cursor: pointer;
                    &:nth-of-type(1)::after {
                        content: '';
                        width: 1px;
                        height: 12px;
                        background: #000;
                        margin: 0 12px;
                    }
                }
                .comment__sort-item--active {
                    color: $color-primary;
                }
            }

            .comment-area__title {
                padding-bottom: 20px;

                text-align: left;
                color: #000;
                font-size: 18px;
                font-weight: bold;

                span {
                    color: #000;
                    font-size: 18px;
                    font-weight: bold;
                    margin-left: 8px;
                }
            }

            .comment__more-btn {
                padding: 10px;
                text-align: center;
                font-size: 14px;
                color: #406599;
                cursor: pointer;

                &:hover {
                    opacity: .8;
                }
            }
        }
    }

    .detail-right-side {
        width: 300px;

    }
}

.detail {
    border-radius: 2px;

    .detail__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
    }

    .detail__cover {
        width: 100%;
        padding-top: 50%;
        background-size: cover;
        background-position: 50%;
        margin-bottom: 30px;
    }

    .detail__title {
        margin-bottom: 16px;
        line-height: 1.6;
        font-size: 30px;
        font-weight: 700;
        color: #000;
    }

    .detail__content {
        line-height: 1.6;
        color: #333;
        font-size: $font-size-Level6;

        ::v-deep img {
            max-width: 70%;
            height: auto;
            display: block;
            margin: 10px auto;
        }

        ::v-deep strong {
            font-weight: bold;
        }

        ::v-deep p {
            margin: 22px 0;

            > code {
                background-color: rgb(255, 245, 245);
                color: rgb(255, 80, 44);
                font-size: 13px;
                padding: 1px 5px;
                border-radius: 2px;
                overflow-x: auto;
            }
        }

        ::v-deep h1 {
            margin-top: 40px;
            margin-bottom: 12px;
            font-size: 26px;
            font-weight: 700;
        }

        ::v-deep h2 {
            margin-top: 24px;
            margin-bottom: 12px;
            font-size: 24px;
            font-weight: 700;
            border-bottom: 1px solid rgb(236, 236, 236);
        }

        ::v-deep h3 {
            margin-top: 15px;
            margin-bottom: 12px;
            font-size: 18px;
            font-weight: 700;
        }

        ::v-deep h4 {
            margin-top: 15px;
            margin-bottom: 12px;
            font-size: 16px;
            font-weight: 700;
        }

        ::v-deep h5 {
            margin-top: 5px;
            margin-bottom: 5px;
            font-size: 14px;
            font-weight: 700;
        }

        ::v-deep code {
            font-size: 13px;
            line-height: 1.8;
            letter-spacing: .6px;
        }

        ::v-deep ol,
        ::v-deep ul {
            padding-left: 28px;
            list-style: initial;
            list-style-type: decimal;
        }

        ::v-deep li {
            padding-left: 6px;
            list-style: initial;
            list-style-type: decimal;
        }

        ::v-deep blockquote {
            color: #666;
            padding: 1px 23px;
            margin: 22px 0;
            border-left: 4px solid #cbcbcb;
            background-color: #f8f8f8;
        }

        ::v-deep a {
            color: #0269c8;
            border-bottom: 1px solid #d1e9ff;
            word-break: break-all;

            &:hover {
                color: #007fff;
            }

            &:active {
                color: #275b8c;
            }
        }
    }
}

.detail__userInfo {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    position: relative;

    .detail__user__name {
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: $font-size-primary;

        span {
            color: #333;
            margin-right: 30px;
        }
    }

    .detail__user__meta {
        letter-spacing: 1px;
        font-size: 14px;
        color: #909090;

        .meta__time {
            margin-right: 10px;
        }
    }
}

.tags {
    margin-top: 30px;

    .tags__title {
        color: #333;
        margin-right: 12px;
    }

    .tag {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        margin: 0 12px 12px 0;
        padding: 2px;
        border-radius: 5px;
        background: #F7F8FA;
        height: 32px;
        padding: 0 12px;
        text-decoration: none;

        .tag__title {
            font-size: 14px;
            color: #999;
        }
    }
}

.author-info {
    display: flex;
    padding: 15px;
    margin: 30px 0;
    background: #f4f4f4;
    cursor: pointer;

    .author__avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }

    .author-info__main {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 2px 0;
        color: #999;
        font-size: 14px;
        margin-left: 10px;

        .author__name {
            font-size: 16px;
            font-weight: bold;
            color: #262626;
        }
    }
}</style>
